import { render, staticRenderFns } from "./MastersBlockList.vue?vue&type=template&id=b6a49692"
import script from "./MastersBlockList.vue?vue&type=script&lang=js"
export * from "./MastersBlockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports